/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { NumericSearch } from './NumericSearch';
import {
    NumericSearchFromJSON,
    NumericSearchFromJSONTyped,
    NumericSearchToJSON,
} from './NumericSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DeliberationMasseSearch
 */
export interface DeliberationMasseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DeliberationMasseSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DeliberationMasseSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof DeliberationMasseSearch
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DeliberationMasseSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DeliberationMasseSearch
     */
    degre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DeliberationMasseSearch
     */
    metier?: TextSearch;
    /**
     * 
     * @type {NumericSearch}
     * @memberof DeliberationMasseSearch
     */
    idclasse?: NumericSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeliberationMasseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeliberationMasseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliberationMasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DeliberationMasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DeliberationMasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeliberationMasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DeliberationMasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DeliberationMasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DeliberationMasseSearch interface.
 */
export function instanceOfDeliberationMasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliberationMasseSearchFromJSON(json: any): DeliberationMasseSearch {
    return DeliberationMasseSearchFromJSONTyped(json, false);
}

export function DeliberationMasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliberationMasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'degre': !exists(json, 'degre') ? undefined : TextSearchFromJSON(json['degre']),
        'metier': !exists(json, 'metier') ? undefined : TextSearchFromJSON(json['metier']),
        'idclasse': !exists(json, 'idclasse') ? undefined : NumericSearchFromJSON(json['idclasse']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DeliberationMasseSearchToJSON(value?: DeliberationMasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'degre': TextSearchToJSON(value.degre),
        'metier': TextSearchToJSON(value.metier),
        'idclasse': NumericSearchToJSON(value.idclasse),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

